// extracted by mini-css-extract-plugin
module.exports = {"list":"Responses-module--list--22-Sd","response":"Responses-module--response--2hung"};